import React from "react";

import { Modal } from "@/components";
import { axiosInstance } from "@/resources/requestInfo";
import {
  getTokenFromStorage,
  getSeenWhatsNew,
  addSeenWhatsNew,
} from "@/utils";

import styles from "./WhatsNewModal.module.scss";

type WhatsNewBanner = {
  id: number;
  title: string;
  description: string;
  img_url: string | null;
};

/**
 * Гейт баннеров «Что нового». Тянет активные баннеры при монтировании,
 * показывает по очереди. Залогиненному бэкенд уже отдаёт только
 * непросмотренные — при закрытии шлём POST /whats-new/:id/seen.
 * Аноним фильтруется по localStorage и там же запоминается.
 */
export const WhatsNewModal: React.FC = () => {
  const [banners, setBanners] = React.useState<WhatsNewBanner[]>([]);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    let mounted = true;

    axiosInstance
      .get<WhatsNewBanner[]>("/whats-new")
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        const isAuth = !!getTokenFromStorage();
        const filtered = isAuth
          ? data
          : data.filter((b) => !getSeenWhatsNew().includes(b.id));

        if (mounted) setBanners(filtered);
      })
      .catch(() => {});

    return () => {
      mounted = false;
    };
  }, []);

  const isOpen = banners.length > 0 && index < banners.length;
  const banner = isOpen ? banners[index] : null;
  const isLast = index >= banners.length - 1;

  const handleNext = () => {
    if (!banner) return;

    if (getTokenFromStorage()) {
      axiosInstance.post(`/whats-new/${banner.id}/seen`).catch(() => {});
    } else {
      addSeenWhatsNew(banner.id);
    }

    setIndex((prev) => prev + 1);
  };

  if (!banner) return null;

  return (
    <Modal
      title={banner.title}
      isOpen={isOpen}
      setIsOpen={handleNext}
      modalWindowWidth={440}
      mobileContentSize="fixed"
    >
      <div className={styles.container}>
        {banner.img_url ? (
          <img src={banner.img_url} alt={banner.title} className={styles.image} />
        ) : null}

        <p className={styles.description}>{banner.description}</p>

        <button className={styles.button} onClick={handleNext}>
          {isLast ? "Понятно" : "Далее"}
        </button>

        {banners.length > 1 ? (
          <div className={styles.dots}>
            {banners.map((_, i) => (
              <span
                key={i}
                className={`${styles.dot} ${i === index ? styles.dotActive : ""}`}
              />
            ))}
          </div>
        ) : null}
      </div>
    </Modal>
  );
};
